import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { GlobalSocketProvider } from "@/context/GlobalSocket";
import BroadcastBanner from "@/components/BroadcastBanner";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Lobby from "@/pages/Lobby";
import GameHub from "@/pages/GameHub";
import Friends from "@/pages/Friends";
import Leaderboard from "@/pages/Leaderboard";
import Profile from "@/pages/Profile";
import Store from "@/pages/Store";
import Loadout from "@/pages/Loadout";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id (synchronous, prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/lobby" element={<Protected><Lobby /></Protected>} />
      <Route path="/game/:roomId" element={<Protected><GameHub /></Protected>} />
      <Route path="/friends" element={<Protected><Friends /></Protected>} />
      <Route path="/leaderboard" element={<Protected><Leaderboard /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/store" element={<Protected><Store /></Protected>} />
      <Route path="/loadout" element={<Protected><Loadout /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
      <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <GlobalSocketProvider>
            <AppRouter />
            <BroadcastBanner />
            <Toaster
              richColors
              position="top-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "rgba(22, 19, 36, 0.95)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#fff",
                },
              }}
            />
          </GlobalSocketProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
